import { useParams } from "react-router-dom";
import { futureModules } from "@/modules/registry";
import { Sparkles } from "lucide-react";

export default function ComingSoon() {
  const { key } = useParams();
  const mod = futureModules.find((m) => m.key === key);
  const Icon = mod?.icon || Sparkles;
  return (
    <div className="max-w-xl mx-auto text-center py-20" data-testid="coming-soon-page">
      <div className="mx-auto grid place-items-center h-16 w-16 rounded-2xl bg-secondary text-primary mb-6">
        <Icon className="h-8 w-8" />
      </div>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-2">Future Module</p>
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-[hsl(148,38%,16%)]">{mod?.title || "Coming soon"}</h1>
      <p className="text-muted-foreground mt-3 leading-relaxed">
        This module is on the Farm Hand roadmap. The app is built modularly, so {mod?.title || "it"} will slot in here
        without disrupting your existing data.
      </p>
      <div className="inline-flex items-center gap-2 mt-6 rounded-full bg-secondary px-4 py-2 text-sm font-medium text-primary">
        <Sparkles className="h-4 w-4" /> In development
      </div>
    </div>
  );
}
